import { motion } from "framer-motion";
import { Building2, ShoppingBag, ShieldCheck, Truck } from "lucide-react";
import { IMAGES } from "@/lib/site";

const services = [
  {
    icon: Building2,
    title: "Sourcing Gros",
    desc: "Accédez à des fournisseurs de grande capacité en Chine et en Corée. Volumes élevés, prix compétitifs, qualité garantie.",
    span: "lg:col-span-2 lg:row-span-1",
    dark: true,
  },
  {
    icon: ShoppingBag,
    title: "Sourcing Détail",
    desc: "Trouvez les meilleurs produits pour votre boutique. Petits volumes, grande variété, service personnalisé.",
    span: "",
  },
  {
    icon: ShieldCheck,
    title: "Vérification Fournisseurs",
    desc: "Nous vérifions chaque fournisseur : certifications, capacités, antécédents. Zéro risque, confiance totale.",
    span: "",
    image: IMAGES.cargo,
  },
  {
    icon: Truck,
    title: "Logistique & Livraison",
    desc: "Gestion complète du transport, des douanes et de la livraison. De l'usine à votre porte, sans stress.",
    span: "lg:col-span-2",
  },
];

export const Services = () => {
  return (
    <section id="services" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-brand-red mb-4">Nos services</p>
          <h2 className="font-display font-bold uppercase tracking-tight leading-none text-brand-navy text-4xl sm:text-5xl">
            Tout ce dont vous avez besoin, sourcé pour vous
          </h2>
          <p className="mt-5 text-slate-600 text-base lg:text-lg">
            De la recherche du produit à la livraison finale, King of Sourcing gère l'intégralité de la chaîne pour tous types de produits.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`service-card-${i}`}
                className={`relative overflow-hidden rounded-lg border p-8 group ${s.span} ${
                  s.dark
                    ? "bg-brand-navy text-white border-white/10 min-h-[240px]"
                    : "bg-slate-50 text-brand-navy border-black/5 min-h-[200px]"
                }`}
              >
                {s.image && (
                  <img
                    src={s.image}
                    alt={s.title}
                    className="absolute inset-0 h-full w-full object-cover opacity-20 group-hover:scale-105 transition-transform duration-500"
                  />
                )}
                <div className="relative">
                  <div
                    className={`inline-flex h-12 w-12 items-center justify-center rounded-md mb-5 ${
                      s.dark ? "bg-brand-goldbright text-brand-navy" : "bg-brand-navy text-white"
                    }`}
                  >
                    <Icon size={22} />
                  </div>
                  <h3 className="font-display font-semibold text-2xl tracking-tight">{s.title}</h3>
                  <p className={`mt-3 text-sm leading-relaxed ${s.dark ? "text-white/70" : "text-slate-600"}`}>
                    {s.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
